import { Avatar } from '@calendly/ui/components/avatar';
import { FullStoryExclude } from '@calendly/ui/components/fullstory-privacy';
import { Option } from '@calendly/ui/components/select';
import classNames from 'classnames';
import { forwardRef } from 'react';
import Highlighter from 'react-highlight-words';
const styledAvatarCss = "s1nd3lqc";
const StyledAvatar = forwardRef((props, ref) => <Avatar ref={ref} {...props} className={classNames(styledAvatarCss, props.className)} />);
const highlightedCss = "hqzcuuo";
const Highlighted = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(highlightedCss, props.className)} />;
});
const Item = ({
  value,
  avatarLetter,
  avatarUrl,
  filterTerm,
  children
}) => <Option value={value}>
    <FullStoryExclude>
      <StyledAvatar size="tiny" letter={avatarLetter} src={avatarUrl} aria-hidden tabIndex={-1} />
      <div>
        {!filterTerm ? children : <Highlighter highlightTag={Highlighted} searchWords={[filterTerm]} textToHighlight={children} autoEscape />}
      </div>
    </FullStoryExclude>
  </Option>;
export default Item;

require("./item.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./item.js");